//@flow
import * as Immutable from 'immutable';

/* eslint-disable max-len */
import { WaybillUnsedSearchResponse } from 'platform/settings/modules/orchestration/models/flow/WaybillUnsedSearchResponse';
import type { WaybillUnsedSearchResponseModelType } from 'platform/settings/modules/orchestration/models/flow/WaybillUnsedSearchResponse';
import { PaginationInfo } from 'common/models/internal/PaginationInfo';
/* eslint-enable max-len */

class InternalWaybillUnsedSearchResponse extends WaybillUnsedSearchResponse {
    static fromJS(
        json: WaybillUnsedSearchResponseModelType
    ): InternalWaybillUnsedSearchResponse {
        const state: Object = Object.assign({}, json);
        state.waybillNumbers = Immutable.List(state.waybillNumbers);
        state.paginationInfo = PaginationInfo.fromJS(state.paginationInfo);
        return new this(Immutable.Map(state));
    }
}

export { InternalWaybillUnsedSearchResponse as WaybillUnsedSearchResponse };
